import { useEffect, useRef } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import useMixpanel from '../useMixpanel';
import useStores from '../useStores';
import {
  browserName,
  deviceType,
  osName,
  osVersion,
} from 'react-device-detect';

export const RTM_IDLE_TIMEOUT_MILLIS = 2 * 60 * 1000;

export default function () {
  const { track, trackFail } = useMixpanel();
  const { rtmStore } = useStores();
  const isVisibleRef = useRef(true);
  const mousePositionRef = useRef<{ x: number | null; y: number | null }>({
    x: null,
    y: null,
  });

  useEffect(() => {
    const handlePointerMove = (e: PointerEvent) => {
      mousePositionRef.current = { x: e.clientX, y: e.clientY };
    };
    window.addEventListener('pointermove', handlePointerMove, {
      passive: true,
    });
    return () => window.removeEventListener('pointermove', handlePointerMove);
  }, []);

  useIdleTimer({
    timeout: RTM_IDLE_TIMEOUT_MILLIS,
    startOnMount: true,
    onIdle: () => {
      rtmStore.setIsIdle(true);
      track('user_idle', {
        idle_timeout: RTM_IDLE_TIMEOUT_MILLIS,
        deviceType,
        browserName,
        osName,
        osVersion,
      });
    },
    onActive: () => {
      rtmStore.setIsIdle(false);
      track('user_active', {
        idle_timeout: RTM_IDLE_TIMEOUT_MILLIS,
        deviceType,
        browserName,
        osName,
        osVersion,
      });
    },
  });
  useEffect(() => {
    const mixpanelTrackTitle = 'rtm tracking';
    const interval = window.setInterval(() => {
      const trackData = {
        mouseX: mousePositionRef.current.x,
        mouseY: mousePositionRef.current.y,
        deviceType,
        browserName,
        osName,
        osVersion,
        patientUuid: rtmStore.patientUuid ?? 'none',
        resource: rtmStore.resource,
      };
      if (document.visibilityState === 'visible') {
        const isTracked = rtmStore.track(0);

        if (isTracked) {
          track(mixpanelTrackTitle, trackData);
        } else {
          trackFail(
            mixpanelTrackTitle,
            {
              ...trackData,
              isIdle: rtmStore.isIdle,
            },
            false
          );
        }
      } else {
        if (isVisibleRef?.current) {
          trackFail(
            mixpanelTrackTitle,
            {
              reason: 'document is no longer visible',
              ...trackData,
            },
            false
          );
        } else {
          console.debug('RTM tracking skipped because document is not visible');
        }
      }
      isVisibleRef.current = document.visibilityState === 'visible';
    }, rtmStore.trackPeriodSeconds * 1000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [rtmStore]);
}
